import { gql, useQuery } from '@apollo/client';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const GET_CURRENT_ACCOUNT = gql`
  query {
    getCurrentAccount {
      _id
      email
      permissionGroup
      permissionGroupId
      stripePaymentMethodId
      profile {
        avatarUrl
        language
        timezone
        timezoneFullFormat
        displayName
        lastName
        phoneNumber
        firstName
        avatarUrl
      }
      hasPassword
    }
  }
`;

export const useGetCurrentAccount = () => {
  const { i18n } = useTranslation();
  const { data, loading } = useQuery(GET_CURRENT_ACCOUNT);
  const { profile = {}, ...account } = data?.getCurrentAccount || {};

  useEffect(() => {
    if (!loading && profile.language) {
      i18n.changeLanguage(profile.language);
    }
  }, [loading, profile.language, i18n]);

  return { loading, profile, account };
};
